import React from 'react';
import {
  BellIcon,
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  DocumentCheckIcon,
  HeartIcon,
  HomeIcon,
  IdentificationIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  SparklesIcon,
  TrophyIcon,
  UserGroupIcon,
  WalletIcon,
} from '@heroicons/react/24/outline';

import type { AppLauncherItem } from '@digiwedge/tee-time-ui';

const iconClassName = 'h-5 w-5';

export const teetimeAppLauncherItems: AppLauncherItem[] = [
  {
    key: '/',
    label: 'Book',
    description: 'Search and book tee times',
    section: 'Play',
    priority: 'primary',
    icon: <HomeIcon className={iconClassName} />,
  },
  {
    key: '/bookings',
    label: 'Bookings',
    description: 'View your tee-time bookings',
    section: 'Play',
    icon: <CalendarDaysIcon className={iconClassName} />,
  },
  {
    key: '/waitlist',
    label: 'Waitlists',
    description: 'Manage tee-time waitlists',
    section: 'Play',
    icon: <ClipboardDocumentListIcon className={iconClassName} />,
  },
  {
    key: '/profile?tab=buddies',
    label: 'Buddies',
    description: 'Manage linked buddies and regular groups',
    section: 'My Golf',
    icon: <UserGroupIcon className={iconClassName} />,
  },
  {
    key: '/profile?tab=favourites',
    label: 'Favorites',
    description: 'Open saved clubs and courses',
    section: 'My Golf',
    icon: <HeartIcon className={iconClassName} />,
  },
  {
    key: '/profile?tab=handicap',
    label: 'Handicap',
    description: 'View handicap details and history',
    section: 'My Golf',
    icon: <IdentificationIcon className={iconClassName} />,
  },
  {
    key: '/tournaments',
    label: 'Competitions',
    description: 'Browse tournaments and competitions',
    section: 'Compete',
    icon: <TrophyIcon className={iconClassName} />,
  },
  {
    key: '/scorecard',
    label: 'Scorecards',
    description: 'Open tournament scorecards',
    section: 'Compete',
    icon: <DocumentCheckIcon className={iconClassName} />,
  },
  {
    key: '/profile?tab=notifications',
    label: 'Alerts',
    description: 'Review notification preferences',
    section: 'Account',
    icon: <BellIcon className={iconClassName} />,
  },
  {
    key: '/wallet',
    label: 'Wallet',
    description: 'View wallet balance and transaction history',
    section: 'Account',
    icon: <WalletIcon className={iconClassName} />,
  },
  {
    key: '/profile?tab=cards',
    label: 'Saved Cards',
    description: 'Manage saved payment cards',
    section: 'Account',
    icon: <CreditCardIcon className={iconClassName} />,
  },
  {
    key: '/settings',
    label: 'Settings',
    description: 'Account, security, MFA, and linked providers',
    section: 'Account',
    icon: <Cog6ToothIcon className={iconClassName} />,
  },
  {
    key: '/courses-near-me',
    label: 'Near Me',
    description: 'Find golf courses near you',
    section: 'Discover',
    icon: <MapPinIcon className={iconClassName} />,
  },
  {
    key: '/specials',
    label: 'Specials',
    description: 'Browse current tee-time specials',
    section: 'Discover',
    icon: <SparklesIcon className={iconClassName} />,
  },
  {
    key: '/search',
    label: 'Search',
    description: 'Search clubs and available tee times',
    section: 'Discover',
    icon: <MagnifyingGlassIcon className={iconClassName} />,
  },
];
